import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ChangePasswordDto } from '../models/change-password-dto.model';
import { PersonMinimalDto } from '../models/person-minimal-dto';
import { CurrentPerson, Person } from '../models/person.model';

@Injectable({
  providedIn: 'root',
})
export class PersonService {
  private httpClient = inject(HttpClient);

  getPersonById(personId: string): Observable<Person> {
    return this.httpClient.get<Person>(`${environment.backendUrl}v1/persons/${personId}`);
  }

  refreshCurrentPerson$ = new BehaviorSubject(null);
  triggerRefresh() {
    this.refreshCurrentPerson$.next(null);
  }

  getCurrentPerson(): Observable<CurrentPerson> {
    return this.httpClient.get<CurrentPerson>(`${environment.backendUrl}v1/CurrentPerson`);
  }

  updateCurrentPersonPassword(changePasswordDto: ChangePasswordDto): Observable<void> {
    return this.httpClient.post<void>(`${environment.backendUrl}v1/Authentication/Password`, changePasswordDto);
  }

  getProjectSafetyCoordinators(projectId: string): Observable<PersonMinimalDto[]> {
    return this.httpClient.get<PersonMinimalDto[]>(
      `${environment.backendUrl}v1/projects/${projectId}/persons/safety-coordinators`,
    );
  }
}
